export default __webpack_public_path__ + "static/media/h.043e3bc5.svg";